import { FaRegEye, FaRegEyeSlash } from 'react-icons/fa';
import { FaCheck } from 'react-icons/fa6';

const passwordRules = [
  { label: 'At least 10 and at most 128 characters', test: (v) => v.length >= 10 && v.length <= 128 },
  { label: 'Upper case letters (A-Z)', test: (v) => /[A-Z]/.test(v) },
  { label: 'Lower case letters (a-z)', test: (v) => /[a-z]/.test(v) },
  { label: 'Numbers (0-9)', test: (v) => /[0-9]/.test(v) },
  { label: 'Symbols (!@#$%&*)', test: (v) => /[!@#$%&*]/.test(v) },
];

export default function AccountInfo({ formik, password, setPassword, showPassword, setShowPassword }) {
  return (
    <div className="flex flex-col gap-4 text-[1rem]">
      <p className="mb-[0.5rem] leading-[1.5] text-[#1b1b1b]">
        You'll be able to track your order and access your online dashboard with your secure account.
      </p>
      <p className="mb-[0.5rem] text-[1rem] font-semibold leading-[1.5] text-black">
        {formik.values.email} is the email address of the account owner.
      </p>

      <label className="mb-[0.25rem] block text-[1rem] font-medium text-black">Set your password</label>
      <div className="relative mb-[0.5rem]">
        <input
          type={showPassword ? 'text' : 'password'}
          className="w-full rounded-lg border border-[#E5E7EB] bg-white px-[1rem] py-[0.625rem] pr-[2.5rem] text-[1rem] text-[#191919]"
          value={password}
          autoComplete="new-password"
          name={`field-${Math.random().toString(36).substring(2, 8)}`}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button
          type="button"
          className="absolute right-[0.75rem] top-1/2 -translate-y-1/2 text-[#191919]"
          onClick={() => setShowPassword((v) => !v)}
          tabIndex={-1}
        >
          {showPassword ? <FaRegEye className="text-[1rem]" /> : <FaRegEyeSlash className="text-[1rem]" />}
        </button>
      </div>

      <div className="mt-[0.5rem] rounded-lg bg-[#F9FAFB] p-[1rem]">
        <p className="mb-[0.5rem] text-[1rem] font-semibold text-black">Your password must include:</p>
        <ul className="space-y-[0.5rem]">
          {passwordRules.map((rule, i) => (
            <li key={i} className="flex items-center text-[1rem] leading-[1.5]">
              <span
                className={`mr-[1rem] flex h-[1.25rem] w-[1.25rem] items-center justify-center rounded-full ${
                  rule.test(password) ? 'bg-[#00863a] text-white' : 'bg-[#F2F2F2] text-red-500'
                }`}
              >
                <FaCheck className="h-[0.75rem] w-[0.75rem]" />
              </span>
              <span className={rule.test(password) ? 'text-black' : 'text-[#1b1b1b]'}>{rule.label}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
